// Leaving a scenario with figures changed and not saved asks first (TX-US-0026). Stay keeps the
// screen as it is, so the changes can be saved; Discard changes leaves.

import Modal from '../ui/Modal.jsx';

export default function UnsavedChangesDialog({ scenarioName, onStay, onDiscard }) {
  return (
    <Modal onClose={onStay}>
      <form onSubmit={(event) => { event.preventDefault(); onDiscard(); }}>
        <h3>Discard unsaved changes?</h3>
        <p className="hint">
          The figures on screen differ from “{scenarioName}” as saved. Leaving loses them; stay to
          save them first.
        </p>
        <menu>
          <button type="button" onClick={onStay} autoFocus>Stay</button>
          <button type="submit">Discard changes</button>
        </menu>
      </form>
    </Modal>
  );
}
